import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetEmailList: false,
  getEmailListMessage: '',
  getEmailListFailed: '',

  isLoadingGetEmailDraft: false,
  getEmailDraftMessage: '',
  getEmailDraftFailed: '',

  isLoadingPostEmailList: false,
  postEmailListMessage: '',
  postEmailListFailed: '',

  isLoadingDeleteEmailList: false,
  deleteEmailListMessage: '',
  deleteEmailListFailed: '',

  isLoadingPatchEmailList: false,
  patchEmailListMessage: '',
  patchEmailListFailed: '',

  isLoadingPostCopyEmailList: false,
  postCopyEmailListMessage: '',
  postCopyEmailListFailed: '',

  isLoadingGetParticularAttendeeNumber: false,
  getParticularAttendeeNumberMessage: '',
  getParticularAttendeeNumberFailed: '',

  isLoadingGetEmailPreview: false,
  getEmailPreviewMessage: '',
  getEmailPreviewFailed: '',
};

const initialState = JSON.parse(JSON.stringify(state));

function emailListReducer(globalState = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initialState,
      };
    case actionTypes.GET_EMAIL_LIST_PENDING:
      return {
        ...globalState,
        isLoadingGetEmailList: true,
      };
    case actionTypes.GET_EMAIL_LIST_FULFILLED:
      return {
        ...globalState,
        isLoadingGetEmailList: false,
        getEmailListMessage: action.data,
        getEmailListFailed: '',
      };
    case actionTypes.GET_EMAIL_LIST_FAILURE:
      return {
        ...globalState,
        isLoadingGetEmailList: false,
        getEmailListMessage: '',
        getEmailListFailed: action.error,
      };
    case actionTypes.GET_EMAIL_DRAFT_PEDNING:
      return {
        ...globalState,
        isLoadingGetEmailDraft: true,
      };
    case actionTypes.GET_EMAIL_DRAFT_FULFILLED:
      return {
        ...globalState,
        isLoadingGetEmailDraft: false,
        getEmailDraftMessage: action.data,
        getEmailDraftFailed: '',
      };
    case actionTypes.GET_EMAIL_DRAFT_FAILURE:
      return {
        ...globalState,
        isLoadingGetEmailDraft: false,
        getEmailDraftMessage: '',
        getEmailDraftFailed: action.error,
      };
    case actionTypes.POST_EMAIL_LIST_PENDING:
      return {
        ...globalState,
        isLoadingPostEmailList: true,
      };
    case actionTypes.POST_EMAIL_LIST_FULFILLED:
      return {
        ...globalState,
        isLoadingPostEmailList: false,
        postEmailListMessage: action.data,
        postEmailListFailed: '',
      };
    case actionTypes.POST_EMAIL_LIST_FAILURE:
      return {
        ...globalState,
        isLoadingPostEmailList: false,
        postEmailListMessage: '',
        postEmailListFailed: action.error,
      };
    case actionTypes.DELETE_EMAIL_LIST_PENDING:
      return {
        ...globalState,
        isLoadingDeleteEmailList: true,
      };
    case actionTypes.DELETE_EMAIL_LIST_FULFILLED:
      return {
        ...globalState,
        isLoadingDeleteEmailList: false,
        deleteEmailListMessage: action.data,
        deleteEmailListFailed: '',
      };
    case actionTypes.DELETE_EMAIL_LIST_FAILURE:
      return {
        ...globalState,
        isLoadingDeleteEmailList: false,
        deleteEmailListMessage: '',
        deleteEmailListFailed: action.error,
      };
    case actionTypes.PATCH_EMAIL_LIST_PENDING:
      return {
        ...globalState,
        isLoadingPatchEmailList: true,
      };
    case actionTypes.PATCH_EMAIL_LIST_FULFILLED:
      return {
        ...globalState,
        isLoadingPatchEmailList: false,
        patchEmailListMessage: action.data,
        patchEmailListFailed: '',
      };
    case actionTypes.PATCH_EMAIL_LIST_FAILURE:
      return {
        ...globalState,
        isLoadingPatchEmailList: false,
        patchEmailListMessage: '',
        patchEmailListFailed: action.error,
      };
    case actionTypes.POST_COPY_EMAIL_LIST_PENDING:
      return {
        ...globalState,
        isLoadingPostCopyEmailList: true,
      };
    case actionTypes.POST_COPY_EMAIL_LIST_FULFILLED:
      return {
        ...globalState,
        isLoadingPostCopyEmailList: false,
        postCopyEmailListMessage: action.data,
        postCopyEmailListFailed: '',
      };
    case actionTypes.POST_COPY_EMAIL_LIST_FAILURE:
      return {
        ...globalState,
        isLoadingPostCopyEmailList: false,
        postCopyEmailListMessage: '',
        postCopyEmailListFailed: action.error,
      };
    case actionTypes.GET_PARTICULAR_ATTENDEE_NUMBER_PENDING:
      return {
        ...globalState,
        isLoadingGetParticularAttendeeNumber: true,
      };
    case actionTypes.GET_PARTICULAR_ATTENDEE_NUMBER_FULFILLED:
      return {
        ...globalState,
        isLoadingGetParticularAttendeeNumber: false,
        getParticularAttendeeNumberMessage: action.data,
        getParticularAttendeeNumberFailed: '',
      };
    case actionTypes.GET_PARTICULAR_ATTENDEE_NUMBER_FAILURE:
      return {
        ...globalState,
        isLoadingGetParticularAttendeeNumber: false,
        getParticularAttendeeNumberMessage: '',
        getParticularAttendeeNumberFailed: action.error,
      };
    case actionTypes.GET_EMAIL_PREVIEW_PENDING:
      return {
        ...globalState,
        isLoadingGetEmailPreview: true,
      };
    case actionTypes.GET_EMAIL_PREVIEW_FULFILLED:
      return {
        ...globalState,
        isLoadingGetEmailPreview: false,
        getEmailPreviewMessage: action.data,
        getEmailPreviewFailed: '',
      };
    case actionTypes.GET_EMAIL_PREVIEW_FAILURE:
      return {
        ...globalState,
        isLoadingGetEmailPreview: false,
        getEmailPreviewMessage: '',
        getEmailPreviewFailed: action.error,
      };
    default:
      return globalState;
  }
}

export { emailListReducer as default };
